import React, {useState} from 'react'
import {ListaDesplegableConTooltip} from '../inputs'
import {BotonSimple} from '../Botones'
import clsx from 'clsx'

const FormularioSeleccionEmpresa = ({
  arregloEmpresas,
  funcionBuscarEmpresa,
}) => {
  const [empresaSeleccionadaId, setEmpresaSeleccionadaId] = useState(0)

  const empresasActivas = arregloEmpresas
    .filter((empresa) => empresa.activa === true)
    .map((elemento) => {
      return {
        Id: elemento.empresaId,
        Nombre: `${elemento.nit} - ${elemento.nombre}`,
      }
    })
  const empresasInactivas = arregloEmpresas
    .filter((empresa) => empresa.activa === false)
    .map((elemento) => {
      return {
        Id: elemento.empresaId,
        Nombre: elemento.nombre,
      }
    })

  return (
    <div className="w-full flex flex-wrap justify-center items-center">
      <span className="w-full text-center text-cendiatra text-3xl font-bold">
        Cuentas con acceso a más de una empresa
      </span>
      <span className="w-full text-center text-cendiatra-verde-3 text-lg font-bold mt-12 mb-8">
        Recuerda, solo puedes consultar una (1) empresa a la vez, cuando inicias
        sesión.
      </span>
      <ListaDesplegableConTooltip
        estilosContenedor={'w-full text-left'}
        estilosLista={clsx(
          'rounded relative block w-full border rounded-lg focus:outline-none sm:text-sm',
          {
            'border-cendiatra': empresaSeleccionadaId,
            'border-cendiatra-rojo-1': !empresaSeleccionadaId,
          }
        )}
        titulo={'Elige la empresa que vas a consultar'}
        opciones={empresasActivas}
        valor={empresaSeleccionadaId}
        onChange={(e) => setEmpresaSeleccionadaId(e.target.value || 0)}
        opcionesDeshabilitadas={empresasInactivas}
      />
      <div className="w-full flex justify-center items-center mt-10 -mb-10">
        <BotonSimple
          texto={'Continuar'}
          estilosBoton={`w-28 h-12 text-white bg-cover rounded-xl text-14px mt-6 ${
            empresaSeleccionadaId
              ? 'bg-fondoBoton'
              : 'bg-cendiatra-gris-2 pointer-events-none'
          } `}
          funcion={() => funcionBuscarEmpresa(empresaSeleccionadaId)}
        />
      </div>
    </div>
  )
}

export default FormularioSeleccionEmpresa
